import React from "react";
import { convertToKebabCase } from "src/helpers/helperFunctions";
import RedDotCircle from "../RedDotCircle";

interface IProps extends React.HTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  id?: string;
  className?: string;
  name?: string;
  index?: number;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  count?: number;
  showCount?: boolean;
}

const TabsButton: React.FC<IProps> = ({
  active,
  className,
  name,
  index,
  id,
  setActiveTab,
  onClick,
  count,
  showCount = true, 
  ...rest
}) => {
  return (
    <button
      id={id || convertToKebabCase(name)}
      className={`lg:px-[1.05vw] px-2.5 tab-height-adjustment w-[80px] 2xl:w-[100px] border flex gap-1 items-center justify-center min-w-fit text-[#3B3B3B] whitespace-nowrap text-center cursor-grab active:cursor-grabbing rounded font-size-16px font-Poppins-Medium relative ${
        active ? "bg-white border-[#E6E6E6]" : "border-transparent"
      } ${className}`}
      onClick={(e) => {
        onClick && onClick(e);
        const target = e.target as HTMLButtonElement;
        e.currentTarget.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
        setActiveTab(name || "");
      }}
      {...rest}
    >
      {name}
      {count ? <RedDotCircle count={count} className="relative !top-0 !right-0" showCount={showCount} /> : null}
    </button>
  );
};

export default TabsButton;